import React from "react";
import reportWebVitals from "./reportWebVitals";
import ReactDOM from "react-dom/client";

// Components
import App from "../src/components/App";
import Header from "./components/Header/Header";
import Marcas from "./components/Marcas";
import Footer from "./components/Footer";
import BannersBottom from "./components/banners_bottom";
//import Testeira from './Components/Testeira';
// STYLE
import "./assets/css/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import VitrineTop from "./components/VitrineTop";
import VitrineMiddle from "./components/VitrineMiddle";
import Descontos from "./components/Descontos";
import Banners from "./components/banners";
import Destaque from "./components/Destaque";
import Install from "./components/Install";
import Forms from "./components/Forms";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Header />
    <App />
    <Descontos />
    <Marcas />
    <VitrineMiddle />
    <Banners />
    <Destaque />
    <BannersBottom />
    <VitrineMiddle />
    <Install />
    <Forms />
    <Footer />
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
